:host {
  display: none; // initially closed
  position: absolute;
  top: 0;
  left: 0;
  z-index: $zindex-topmost;
  box-shadow: 0 0 4px 0 rgba($color-black, 0.2);
  max-width: 259px; //specified in the design
  min-width: 125px;
  border-radius: $border-radius-large;
}

// so that screen readers read out the number of elements
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
